var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAutoMode = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62688 10.8294L9.13174 9.41468H6.86826L6.37312 10.8294H5.02918L7.29266 4.46331H8.70734L10.9708 10.8294H9.62688ZM13.6587 5.65871V2.34129H10.3413L8 0L5.65871 2.34129H2.34129V5.65871L0 8L2.34129 10.3413V13.6587H5.65871L8 16L10.3413 13.6587H13.6587V10.3413L16 8L13.6587 5.65871ZM7.18656 8.45977H8.81344L8 5.87799L7.18656 8.45977Z",
    fill: "#595959"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAutoMode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/auto-mode.9c30224b.svg";
export { ForwardRef as ReactComponent };